<template>
    <div class="writing">
      <Row style="background:#eee;padding:20px">
        <i-col span="22" style="width: 100%;">
          <Card :bordered="false">
            <Card dis-hover>
              <p slot="title" v-html="" style="height: auto;font-weight: normal;">Academic Writing Part 1
                <br/>
                You should spend about 20 minutes on this task. Write at least 150 words.</p>
              <div :class="isPhone ? '' : 'writing'">
                <div class="writing-item">
                  <p>The chart below shows the number of trips made by children in one country in 1990 and 2010 to travel to and from school using different modes of transport.
                    Summarise the information by selecting and reporting the main features, and make comparisons where relevant.</p>
                  <img  src="https://s3-eu-west-1.amazonaws.com/oep2stt/sample-academic-writing-part-1/test-content/IWAC1365-10-0-9.PNG"  style="width: 100%"  @click="viewImg"/>
                </div>
                <div class="textarea writing-item">
                  <Input v-model="value6" type="textarea" :rows="4" :autosize="{minRows:30,maxRows:30}"/>
                </div>
              </div>
            </Card>
            <p slot="title">Questions</p>
          </Card>
        </i-col>
      </Row>
    </div>
</template>

<script>
    export default {
        name: "Writing",
        props:{
          isPhone:Boolean
        },
        data(){
          return{
            value6:''
          }
        },
        methods:{
          viewImg(event){
              const imgNode=event.currentTarget;
              if(!imgNode.viewer){
                $(imgNode).viewer();
                imgNode.click();
              }else{
                $(imgNode).viewer();
              }
          },
        }
    }
</script>

<style scoped lang="stylus">
   .ivu-card-head p{
    overflow visible!important;
    white-space normal!important;
  }
  .writing
    display: flex
    justify-content: space-between
  .writing-item
    width: 48%
  textarea
    resize:none
</style>



// WEBPACK FOOTER //
// src/pages/Exercise/children/Writing.vue